/* eslint-disable prettier/prettier */
import { useCallback, useState } from 'react';
import { courseModuleService } from '../services/courseModule.service';

export const useProgramModules = () => {
	const [modules, setModules] = useState<any[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<any>(null);

	const fetchProgramModules = useCallback(async (courseId: string) => {
		setLoading(true);
		setError(null);

		try {
			console.log('FETCHING COURSE ID =>', courseId);

			const res = await courseModuleService.getCourseModules(courseId);

			console.log('MODULE API RESPONSE =>', res.data);

			// 🔥 FIX
			const data = Array.isArray(res.data)
				? res.data
				: res.data?.data || [];

			console.log('FINAL MODULE DATA =>', data);

			setModules(data);

			return data;
		} catch (err: any) {
			console.log('MODULE FETCH ERROR =>', err);

			setError(err);
			return [];
		} finally {
			setLoading(false);
		}
	}, []);

	return {
		modules,
		loading,
		error,
		fetchProgramModules,
	};
};
